<template>
    <div id="learn-four" >
      <div class="background-learn background-steps z-index-10"></div>
      <div class="learn-four-desktop" v-if="$vuetify.breakpoint.mdAndUp">
        <!-- <img :style="buttonAddPos" class="absolute decor-null z-index-10" src="@/assets/images/learn/Ellipse 95.png"> -->
        <!-- <img :style="buttonAddPos" class="absolute decor-zero z-index-10" src="@/assets/images/learn/Rectangle 402.png" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}"> -->
        <img :style="buttonAddPos" class="absolute decor-one z-index-10" src="@/assets/images/learn/Ellipse 92.png" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
        <div :style="buttonAddPos" class="flex absolute information z-index-10" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
          <img class="absolute decor-two" src="@/assets/images/learn/robot_4.png" :class="{sm:$vuetify.breakpoint.sm}">
          <div class="absolute text" :class="{sm:$vuetify.breakpoint.sm}">
            <div class="roboto-normal-24 clr-black mt-xl-12 mt-lg-12 mt-md-12 mt-sm-2">Здесь можно создавать заметки и добавлять вложения!</div>
            <div class="flex-center pointer mt-12 pt-6" @click="endLearn()">
              <div class="roboto-normal-24 clr-white">Понятно!</div>
              <v-icon class="ml-1 opacity-max" x-large color="white">mdi-chevron-right</v-icon>
            </div>
          </div>
        </div>
        <div class="sub_temp absolute" :style="subPos">
            <div class="label">Название заметки</div>
            <hr color="lightgray"/>
            <div class="body">Содержимое</div>
        </div>
      </div>
      <div class="learn-four-mobile" v-else>
        <img class="button-add links absolute z-index-100" :style="buttonAddPos" height="33.91px" src="@/assets/images/components/button-add-blue.png" :class="{xs:$vuetify.breakpoint.xs}">
        <img :style="buttonAddPos" class="absolute decor-null z-index-10" src="@/assets/images/learn/Ellipse 95.png">
        <img :style="buttonAddPos" class="absolute decor-zero z-index-10" src="@/assets/images/learn/Rectangle 547.png">
        <img class="absolute decor-one z-index-10" src="@/assets/images/learn/robot_4_mobile.png">
        <img class="absolute decor-two z-index-10" src="@/assets/images/learn/Ellipse 120.png">
        <div class="absolute text z-index-10">
          <div class="roboto-normal-18 clr-black-38 mt-4">Здесь можно создавать заметки!</div>
          <div class="flex-center pointer mt-8 pt-4" @click="endLearn()">
            <div class="roboto-normal-24 clr-white">Понятно!</div>
            <v-icon class="ml-1 opacity-max" x-large color="white">mdi-chevron-right</v-icon>
          </div>
        </div>
      </div>
      <!-- <img class="button-add links absolute z-index-100" :style="buttonAddPos" height="33.91px" src="@/assets/images/components/button-add-blue.png" :class="{xs:$vuetify.breakpoint.xs}"> -->
    </div>
</template>

<script lang='ts'>
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'
    import { mapActions } from 'vuex'

    export default Vue.extend({
        props: {
            // item: Object as PropType<Block>,
        },
        components: {

        },
        data() {
            return {
                buttonAddPos: {left: '', top: ''},
                subPos: {left: '', top: '', width: '', height: ''},
            }
        },
        computed: {

        },
        methods: {
            ...mapActions(['addTheme','saveOrderThemes','setLearned']),
            endLearn() {
                this.$router.push("/")
                this.setLearned()
            },
            updatePlusPositions() {
                const el = document.querySelector('.add-sub img')
                const buttonAddRect = el && el.getBoundingClientRect()
                if (buttonAddRect) {                
                    this.buttonAddPos.left = Math.floor(buttonAddRect.left) + 'px'
                    this.buttonAddPos.top = el.offsetTop + 'px'
                }
                const elSub = document.querySelector('.subs-body')
                const subAddRect = elSub && elSub.getBoundingClientRect()
                if (subAddRect) {
                    this.subPos.top = Math.floor(subAddRect.top) + 'px'
                    this.subPos.left = Math.floor(subAddRect.left) + 'px'
                    this.subPos.width = Math.floor(subAddRect.width) + 'px'
                    this.subPos.height = Math.floor(subAddRect.height) + 'px'
                }
            }
        },
        mounted() {
            this.$nextTick(this.updatePlusPositions)
            // setInterval(() => {

            // })
        }
    })

    </script>

<style lang="scss" scoped>
    .sub_temp{
        background: white;
        z-index: 10;
        box-shadow: -3px -3px 11px 7px rgb(255 255 255);
        max-height: 400px;
        max-width: 420px;
        hr {
          margin-top: 10px;
          margin-left: 10px;
          margin-right: 10px;
        }
        .label{
          margin-top: 20px;
          margin-left: 20px;
          color: gray;
        }
        .body{
          margin-top: 20px;
          margin-left: 20px;
          color: gray;
        }
    }
  #learn-four{
    .learn-four-desktop {
      .decor-null {
        width: 250px;
        height: 200px;
        margin-left: -110px;
        margin-top: -80px;
      }
      .decor-zero {
        margin-top: 50px;
        margin-left: -70px;
        &.lg {
          height:270px;
          transform: rotate(20deg);
        }
        &.md {
          height:170px;
          transform: rotate(50deg);
          margin-top: 80px;
          margin-left: -90px;
        }
        &.sm {
          height:170px;
          transform: rotate(58deg);
          margin-top: 110px;
          margin-left: -90px;
        }
      }
      .decor-one {
        margin-top: 240px;
        // margin-left: -420px;
        &.sm {
          width:590px;
          margin-left: 30px;
        }
      }
      .information {
        margin-top: 260px;
        // margin-left: -340px;
        
        &.sm{
          margin-left: 40px;
        }
        .decor-two {
          transform: rotateY(180deg);
          left:35px;
          &.sm {
            top:-20px;
            left:-20px;
            height:178px;
          }
        }
        .text {
          top:35px;
          left:300px;
          width:325px;
          &.sm {
            top:-10px;
            left:190px;
            width:280px;
          }
        }
      }
    }
    .learn-four-mobile {
      .decor-null {
        height:80px;
        width:80px;
        margin-top: -20px;
        margin-left: -20px;
      }
      .decor-zero {
        top:428px;
        margin-left: -34px;
        margin-top: -31px;
      }
      .decor-one {
        top:600px;
        left:37%;
      }
      .decor-two {
        top:686px;
        left:-7%;
      }
      .text {
        top:776px;
        left:90px;
        width:220px;
      }
    }
  }
</style>
